<template>
    <div class="pagination">
        <div class="location noselect">
            <span>共{{totalItems}}条稿件 第{{currentPage}}/{{totalPages}}页</span>
        </div>
        <dropDownMenu :items="pageSizes" @change="changePageSize" :value="'name'" :unit="'条/页'" :selectedItem.sync="selectedPageSize" v-if="hasSelectPageSize"></dropDownMenu>
        <ul class="paging noselect">
            <li :class="{disabled:currentPage==1}" @click="selectPage(1)" class="first">首页</li>
            <li :class="{disabled:currentPage==1}" @click="prevNext(-1)" class="prev">上一页</li>
            <li @click="selectPage(value)" v-for="value in showItems" :class="{active:currentPage==value}" v-text="value"></li>
            <li :class="{disabled:currentPage==totalPages}" @click="prevNext(1)" class="next">下一页</li>
            <li :class="{disabled:currentPage==totalPages}" @click="selectPage(totalPages)" class="last">末页</li>
        </ul>
        <div class="go_to" v-if="hasJumpPage">
            <span class="one">跳至</span>
            <input v-model="willPage" @keypress="goToWillPage" class="form-control" type="" name="">
            <span class="two">页</span>
        </div>
    </div>
</template>
<script>
import dropDownMenu from './dropDownMenu'
export default {
    name: 'pagination',
    components: {
        dropDownMenu
    },
    props: {
        showPagesNum: {
            type: Number,
            default: 8
        },
        pageSize: {
            type: [String, Number],
            default: '20'
        },
        currentPage: {
            type: [String, Number],
            default: '1'
        },
        totalPages: {
            type: [String, Number]
        },
        totalItems: {
            type: [String, Number]
        },
        hasJumpPage: {
            type: Boolean,
            default: false
        },
        hasSelectPageSize:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            pageSizes: [{
                name: '20'
            }, {
                name: '50'
            }, {
                name: '100'
            }],
            selectedPageSize: {
                name: this.pageSize.toString()
            },
            willPage: 1
        }
    },
    methods: {
        /**
         * [selectPage description] 选择指定页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        selectPage(item) {
            this.$emit("update:currentPage", item);
            this.$emit("change");
        },
        /**
         * [prevNext description] 上一页或下一页
         * @param  {[type]} value [description] 值
         * @return {[type]}       [description]
         */
        prevNext(value) {
            let willPage = Number(this.currentPage) + value;
            if (willPage == 0 || willPage > this.totalPages) {
                return;
            }
            this.selectPage(willPage);
        },
        /**
         * [changePageSize description] 改变单页大小
         * @return {[type]} [description]
         */
        changePageSize() {
            this.$emit("update:currentPage", 1);
            this.$emit("update:pageSize", this.selectedPageSize.name.toString());
            this.$emit("change");
        },
        /**
         * [goToWillPage description] 跳转到指定页
         * @return {[type]} [description]
         */
        goToWillPage($event) {
            if ($event.keyCode !== 13) return;
            if (isNaN(this.willPage)) {
                alert("请输入数字");
                return;
            }
            let willPage = Number(this.willPage);
            if (willPage <= 0) {
                willPage = 1;
            } else if (willPage > this.totalPages) {
                willPage = Number(this.totalPages);
            }
            this.willPage = willPage;
            this.selectPage(willPage);
        }
    },
    computed: {
        showItems() {
            let different = this.currentPage % this.showPagesNum
            let start = different === 0 ? this.currentPage - this.showPagesNum + 1 : this.currentPage - different + 1;
            let array = [];
            let end = (start + this.showPagesNum) > (this.totalPages + 1) ? (this.totalPages + 1) : (start + this.showPagesNum);
            for (let i = start; i < end; i++) {
                array.push(i);
            }
            return array;
        }
    }
}
</script>
<style lang="less" scoped>
.pagination {
    font-size: 12px;
    display: inline-block;
    position: relative;
    text-align: center;
    line-height: initial;

    .location {
        display: inline-block;
        font-size: 14px;
        color: #35415E;
        margin-right: 24px;
        left: 0;
        top: 50%;
        position: relative;
        line-height: 25px;
    }

    .paging {
        display: inline-block;
        position: relative;
        vertical-align: middle;

        .first,
        .last,
        .prev,
        .next {
            padding: 0 8px;
        }

        li {

            // &.prev {
            //     transform: rotate(90deg);
            //     &:after {
            //         content: "V";
            //     }
            // }
            // &.next {
            //     transform: rotate(-90deg);
            //     &:after {
            //         content: "V";
            //     }
            // }
            &.disabled {
                opacity: 0.6;
                cursor: not-allowed;

                &:hover {
                    color: #304150;
                    background-color: white;
                    border: 1px solid rgba(190, 190, 190, 1);
                }
            }

            font-size:12px;
            color:#304150;
            margin-right:12px;
            cursor: pointer;
            line-height: 25px;
            min-width: 25px;
            box-sizing:border-box;
            height: 25px;
            text-align: center;
            float: left;
            border: 1px solid rgba(190, 190, 190, 1);

            border-radius: 3px;

            &:hover,
            &.active {
                color: white;
                background: #E62529;
                border-color: #E62529;
            }
        }
    }

    .drop_down_menu {
        position: relative;
        margin-left: 10px;
        margin-right: 30px;
        width: 70px;
        border-radius: 3px;
        border: 1px solid rgba(190, 190, 190, 1);
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding-left: 5px;

        /deep/ .select_item {
            width: 70px;
        }

        /deep/ .menu .common_li {
            font-size: 12px;
        }

        /deep/.triangle {
            top: -1px;
        }
    }

    .go_to {
        margin-left: 22px;
        display: inline-block;
        vertical-align: middle;

        .one {
            margin-right: 12px;
        }

        .two {
            margin-left: 12px;
        }

        input {
            width: 40px;
            height: 25px;
            line-height: 25px;
            padding-left: 5px;
        }
    }
}
</style>